let mainVisualTrans = {
  "main-visual-01": "Going",
  "main-visual-02": "Beyond",
  "main-visual-03": "Borders",
};
// if (window.__IS_LOGGED_IN__)

export default {
  ...mainVisualTrans,
  "footer-01":
    "Glocal K is a group company to Kyushu Asahi Broadcasting, a leading broadcasting station in Kyushu.",
  "footer-02":
    "Glocal K supports “FURUSATO WISH” which is a KBC × Fukuoka’s project. KBC has been featuring attractive places, foods, people, culture of each 60 cities & districts in Fukuoka on TV and Radio.",
  "visit-site": "Click here",
  copyright: " ",
  "company-name-ttl": "Company name",
  "company-name": "Glocal K Co., Ltd.",
  "company-address-ttl": "Address",
  "company-address": "1F KBC building, 1-1-1 Nagahama Chuo-ku,Fukuoka city, Fukuoka 810-8571",
  "company-ceo-ttl": "President and CEO",
  "company-ceo": "Hideki Mochidome, CEO",
  "company-business-ttl": "Business",
  "company-business": "Contents producing and distribution, filming coordination, consulting",
  "company-stock-ttl": "Common stock",
  "company-stock": "50 million yen",
  "company-incorporated-ttl": "Incorporated",
  "company-incorporated": "Apr.7,2020",
  "company-capital-ttl": "Capital key",
  "company-capital": "Kyushu Asahi Broadcasting Co., Ltd.  100％",
};
